import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { EVehicleType } from '@/redux/modules/globalHeader';
import { getHeaderSearchVehicleTypeFilter } from '@/redux/selectors/globalHeader';

import { FilterButton } from './FilterButton';

type TVehicleTypeFilterButtonProps = {
  toggleFilter: () => void;
  className?: string;
};

export const VehicleTypeFilterButton = ({
  toggleFilter,
  className,
}: TVehicleTypeFilterButtonProps) => {
  const intl = useIntl();
  const vehicleType = useSelector(getHeaderSearchVehicleTypeFilter);
  return (
    <FilterButton
      aria-label={intl.formatMessage({
        defaultMessage: 'Click to select the vehicle type',
        id: 'frUpX+',
        description: 'Home Search Widget > Vehicle Type Filter Aria Label',
      })}
      label={intl.formatMessage({
        defaultMessage: 'Rental type',
        id: '8dNTxb',
        description: 'Home Search Widget > Vehicle Type Filter Label',
      })}
      value={(() => {
        if (vehicleType === EVehicleType.DRIVABLE) {
          return intl.formatMessage({
            defaultMessage: 'Drivable',
            id: 'CYJYZT',
            description: 'Home Search Widget > Vehicle Type Filter Drive Selection',
          });
        }

        if (vehicleType === EVehicleType.TOWABLE) {
          return intl.formatMessage({
            defaultMessage: 'Towable',
            id: '/3+JyV',
            description: 'Home Search Widget > Vehicle Type Filter Tow Selection',
          });
        }

        if (vehicleType === EVehicleType.DELIVERABLES) {
          return intl.formatMessage({
            defaultMessage: 'Deliverable',
            id: 'cTkniK',
            description: 'Home Search Widget > Vehicle Type Filter Delivery Selection',
          });
        }

        return intl.formatMessage({
          defaultMessage: 'All types',
          id: 'DF/rzB',
          description: 'Home Search Widget > Vehicle Type Filter Placeholder',
        });
      })()}
      onClick={toggleFilter}
      className={className}
    />
  );
};
